import { getLangeKey } from '@/data/i18n/translateLang'

export const tableHeaderMappingList = {
  [getLangeKey('开门方向')]: 'openDir',
  [getLangeKey('板号')]: 'plankID',
  [getLangeKey('材质')]: 'matCode',
  [getLangeKey('颜色')]: 'texture',
  [getLangeKey('板件名称')]: 'partName',
  [getLangeKey('板件名称(不含房间柜体)')]: 'partNameWithoutRoomCabinet',
  [getLangeKey('成品长度')]: 'specHeight',
  [getLangeKey('成品宽度')]: 'specWidth',
  [getLangeKey('成品面积(㎡)')]: 'finishedArea',
  [getLangeKey('备注信息')]: 'remarks',
  [getLangeKey('备注信息1')]: 'remark1',
  [getLangeKey('备注信息2')]: 'remark2',
  [getLangeKey('备注信息3')]: 'remark3',
  [getLangeKey('备注信息4')]: 'remark4',
  [getLangeKey('备注信息5')]: 'remark5',
  [getLangeKey('备注信息6')]: 'remark6',
  [getLangeKey('备注信息7')]: 'remark7',
  [getLangeKey('备注信息8')]: 'remark8',
  [getLangeKey('备注信息9')]: 'remark9',
  [getLangeKey('备注信息10')]: 'remark10',
  [getLangeKey('备注信息11')]: 'remark11',
  [getLangeKey('备注信息12')]: 'remark12',
  [getLangeKey('备注信息13')]: 'remark13',
  [getLangeKey('备注信息14')]: 'remark14',
  [getLangeKey('备注信息15')]: 'remark15',
  [getLangeKey('备注信息16')]: 'remark16',
  [getLangeKey('数量')]: 'amount',
  [getLangeKey('面积')]: 'area',
  [getLangeKey('左封边')]: 'leftEdge',
  [getLangeKey('右封边')]: 'rightEdge',
  [getLangeKey('前封边')]: 'frontEdge',
  [getLangeKey('后封边')]: 'backEdge',
  [getLangeKey('纹理')]: 'texDir',
  [getLangeKey('厚度')]: 'thick',
  [getLangeKey('项目地址')]: 'address',
  [getLangeKey('板件条码')]: 'oriPlankNum',
  [getLangeKey('客户')]: 'customer_name',
  [getLangeKey('房间')]: 'roomName',
  [getLangeKey('订单号')]: 'orderNo',
  [getLangeKey('柜体')]: 'loc',
  [getLangeKey('孔槽数量')]: 'hsInfo',
  [getLangeKey('异形')]: 'specialShape',
  [getLangeKey('门板')]: 'type',
  [getLangeKey('板件备注')]: 'plank_remarks',
  [getLangeKey('房间备注')]: 'remark',
  // 新增导出csv高光板字段
  [getLangeKey('高光板')]: 'is_high_gloss_plank',
  [getLangeKey('铰链数据')]: 'hingeInfo',
  [getLangeKey('特殊工艺')]: 'process_label',
  // 额外的中文处理，用于部分极限情况下翻译未正常处理，导致无法正常匹配(对应的添加字段都需要两套)
  ['板号']: 'plankID',
  ['材质']: 'matCode',
  ['颜色']: 'texture',
  ['板件名称']: 'partName',
  ['板件名称(不含房间柜体)']: 'partNameWithoutRoomCabinet',
  ['成品长度']: 'specHeight',
  ['成品宽度']: 'specWidth',
  ['成品面积(㎡)']: 'finishedArea',
  ['备注信息']: 'remarks',
  ['备注信息1']: 'remark1',
  ['备注信息2']: 'remark2',
  ['备注信息3']: 'remark3',
  ['备注信息4']: 'remark4',
  ['备注信息5']: 'remark5',
  ['备注信息6']: 'remark6',
  ['备注信息7']: 'remark7',
  ['备注信息8']: 'remark8',
  ['备注信息9']: 'remark9',
  ['备注信息10']: 'remark10',
  ['备注信息11']: 'remark11',
  ['备注信息12']: 'remark12',
  ['备注信息13']: 'remark13',
  ['备注信息14']: 'remark14',
  ['备注信息15']: 'remark15',
  ['备注信息16']: 'remark16',
  ['数量']: 'amount',
  ['面积']: 'area',
  ['左封边']: 'leftEdge',
  ['右封边']: 'rightEdge',
  ['前封边']: 'frontEdge',
  ['后封边']: 'backEdge',
  ['纹理']: 'texDir',
  ['厚度']: 'thick',
  ['项目地址']: 'address',
  ['板件条码']: 'oriPlankNum',
  ['客户']: 'customer_name',
  ['房间']: 'roomName',
  ['订单号']: 'orderNo',
  ['柜体']: 'loc',
  ['孔槽数量']: 'hsInfo',
  ['异形']: 'specialShape',
  ['门板']: 'type',
  ['板件备注']: 'plank_remarks',
  ['房间备注']: 'remark',
  ['高光板']: 'is_high_gloss_plank',
  ['开门方向']: 'openDir',
  ['铰链数据']: 'hingeInfo',
  ['订单备注']: 'order_remark',
  ['特殊工艺']: 'process_label',
} as const

export const surplusTableHeaderMappingList = {
  ['余料名称']: 'name',
  ['板件条码']: 'plankNum',
  ['板材材质']: 'type',
  ['板材颜色']: 'color',
  ['板材形状']: 'shape',
  ['厚度']: 'thick',
  ['长度']: 'long',
  ['短边长度']: 'min_long',
  ['宽度']: 'width',
  ['短边宽度']: 'min_width',
  ['纹理']: 'texDir',
  ['面积']: 'area',
  ['高光板']: 'is_high_gloss_plank',
  ['高光面']: 'highlight_surface',
  ['修边']: 'surplus_trim_edge',
  ['添加时间']: 'create_time',
  ['所在余料库']: 'branch_name',
  ['来源订单地址']: 'from_address',
  ['来源订单号']: 'from_order_num',
  ['备注']: 'remark',
} as const

export const surplusKeyMap = new Map([
  ['余料名称', 'name'],
  ['板材材质', 'type'],
  ['板材颜色', 'color'],
  ['板材形状', 'shape'],
  ['厚度', 'thick'],
  ['长度', 'long'],
  ['短边长度', 'min_long'],
  ['宽度', 'width'],
  ['短边宽度', 'min_width'],
  ['高光板', 'is_high_gloss_plank'],
  ['修边', 'surplus_trim_edge'],
  // ['板件条码', 'plankNum'],
])
